import { takeLatest, call, put } from "redux-saga/effects";
import api from "Util/api";
import { callSuccess, callFail } from "Util/callback";

// Actions
const types = {
    GET_CULTURE_ANSWERS_REQUESTED: "GET_CULTURE_ANSWERS_REQUESTED",
    GET_CULTURE_ANSWERS_SUCCEEDED: "GET_CULTURE_ANSWERS_SUCCEEDED",
    GET_CULTURE_ANSWERS_FAILED: "GET_CULTURE_ANSWERS_FAILED",
    SEND_CULTURE_ANSWERS_REQUESTED: "SEND_CULTURE_ANSWERS_REQUESTED",
    SEND_CULTURE_ANSWERS_SUCCEEDED: "SEND_CULTURE_ANSWERS_SUCCEEDED",
    SEND_CULTURE_ANSWERS_FAILED: "SEND_CULTURE_ANSWERS_FAILED"
};

// Action Creators
export const actions = {
    get: (categoryId, callback) => {
        return {
            type: types.GET_CULTURE_ANSWERS_REQUESTED,
            categoryId,
            callback
        };
    },
    send: (categoryId, answers, callback) => {
        return {
            type: types.SEND_CULTURE_ANSWERS_REQUESTED,
            answers,
            categoryId,
            callback
        };
    }
};

// Default state
const defaultState = {
    data: {},
    error: "",
    loading: true
};

// Reducers
export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case types.SEND_CULTURE_ANSWERS_REQUESTED:
        case types.GET_CULTURE_ANSWERS_REQUESTED:
            return {
                ...state,
                loading: true
            };
        case types.SEND_CULTURE_ANSWERS_SUCCEEDED:
        case types.GET_CULTURE_ANSWERS_SUCCEEDED:
            return {
                data: {
                    ...state.data,
                    [action.payload.categoryId]: action.payload.data.data
                },
                error: "",
                loading: false
            };
        case types.SEND_CULTURE_ANSWERS_FAILED:
        case types.GET_CULTURE_ANSWERS_FAILED:
            return {
                ...state,
                error: action.payload,
                loading: false
            };
        default:
            return state;
    }
}

// Sagas
export function* saga() {
    yield takeLatest(types.SEND_CULTURE_ANSWERS_REQUESTED, sendWorker);
    yield takeLatest(types.GET_CULTURE_ANSWERS_REQUESTED, getWorker);
}

// Saga callback
function* sendWorker({ categoryId, answers, callback }) {
    try {
        const response = yield call(send, { categoryId, answers });

        if (!response.ok) {
            throw response.data;
        }

        yield put({
            type: types.SEND_CULTURE_ANSWERS_SUCCEEDED,
            payload: {
                categoryId,
                data: {
                    data: answers.map(a => ({
                        questionId: a.question_id,
                        answerValue: a.value
                    }))
                }
            }
        });

        callSuccess(callback, response.data);
    } catch (e) {
        yield put({
            type: types.SEND_CULTURE_ANSWERS_FAILED,
            payload: e.errors
        });
        callFail(callback, e.errors);
    }
}

function* getWorker({ categoryId, callback }) {
    try {
        const response = yield call(get, { categoryId });

        if (!response.ok) {
            throw response.data;
        }

        yield put({
            type: types.GET_CULTURE_ANSWERS_SUCCEEDED,
            payload: { categoryId, data: response.data }
        });

        callSuccess(callback, response.data);
    } catch (e) {
        yield put({
            type: types.GET_CULTURE_ANSWERS_FAILED,
            payload: e.errors
        });
        callFail(callback, e.errors);
    }
}

// API call
function send({ categoryId, answers }) {
    return api.post(`/api/culture-test/category/answers`, {
        category_id: categoryId,
        answers
    });
}

function get({ categoryId }) {
    return api.get(`/api/culture-test/answers/category/${categoryId}`);
}
